import React, { useEffect, useRef } from "react";
import "./homeproductcard.css";
import { homeProductData } from "./homeData";
import ScroolCard from "./templates/ScroolCard";
import {  useScroll } from "motion/react";
import { BASEURL } from "../../../../utils/BaseUrl";
import { useQuery } from "react-query";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const HomeProductCard = () => {
  const container = useRef(null);

  const { scrollYProgress } = useScroll({
    target: container,
    offset: ["start start", "end end"],
  });

    const { data,isLoading } = useQuery({
      queryKey: "getkeyFeatures",
      queryFn: () =>
        axios.get(`${BASEURL}key_features`).then((res) => {
          return res?.data;
        }),
    });

  return (
    <div ref={container} className="lg:max-w-screen-lg homeproduct-cardbox py-10">
      {isLoading ?(
              <Skeleton className="homeproduct_insidebox" />
            ): data?.map((v, i) => {
        const targetScale = 1 - (homeProductData.length - i) * 0.05;
        return (
          <ScroolCard
            key={i}
            i={i}
            v={v}
            progress={scrollYProgress}
            range={[i * 0.25, 1]}
            targetScale={targetScale}
          />
        );
      })}
    </div>
  );
};

export default HomeProductCard;
